var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmallArrow = function SvgSmallArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 8,
    viewBox: "0 0 17 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.785645 3.48038C0.498669 3.48038 0.266029 3.71302 0.266029 4C0.266029 4.28698 0.498669 4.51962 0.785645 4.51962V3.48038ZM16.5816 4.36742C16.7846 4.1645 16.7846 3.8355 16.5816 3.63258L13.2748 0.325765C13.0719 0.122843 12.7429 0.122843 12.54 0.325765C12.3371 0.528688 12.3371 0.85769 12.54 1.06061L15.4794 4L12.54 6.93939C12.3371 7.14231 12.3371 7.47131 12.54 7.67423C12.7429 7.87716 13.0719 7.87716 13.2748 7.67423L16.5816 4.36742ZM0.785645 4.51962H16.2142V3.48038H0.785645V4.51962Z",
    fill: "#646464"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmallArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/smallArrow.781377d6e46861d97443cbe019ebc67e.blank.svg";